import { render } from "./PaywallToggle.vue?vue&type=template&id=6b47793f&scoped=true"
import script from "./PaywallToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallToggle.vue?vue&type=script&setup=true&lang=js"

import "./PaywallToggle.vue?vue&type=style&index=0&id=6b47793f&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b47793f"],['__file',"src/views/paywall/PaywallToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b47793f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b47793f', __exports__)) {
    console.log('reload')
    api.reload('6b47793f', __exports__)
  }
  
  module.hot.accept("./PaywallToggle.vue?vue&type=template&id=6b47793f&scoped=true", () => {
    console.log('re-render')
    api.rerender('6b47793f', render)
  })

}


export default __exports__